<template>
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.25 0C6.25312 0 5.4375 0.7875 5.4375 1.75V26.25C5.4375 27.2125 6.25312 28 7.25 28H25.375C26.3719 28 27.1875 27.2125 27.1875 26.25V7L19.9375 0H7.25Z"
      fill="#E2E5E7" />
    <path
      d="M21.75 7H27.1875L19.9375 0V5.25C19.9375 6.2125 20.7531 7 21.75 7Z"
      fill="#B0B7BD" />
    <path d="M27.1875 12.25L21.75 7H27.1875V12.25Z" fill="#CAD1D8" />
    <path
      d="M23.5625 22.75C23.5625 23.2313 23.1547 23.625 22.6562 23.625H2.71875C2.22031 23.625 1.8125 23.2313 1.8125 22.75V14C1.8125 13.5187 2.22031 13.125 2.71875 13.125H22.6562C23.1547 13.125 23.5625 13.5187 23.5625 14V22.75Z"
      fill="#F15642" />
    <path
      d="M5.76367 16.5786C5.76367 16.3476 5.95217 16.0956 6.25577 16.0956H7.92961C8.87211 16.0956 9.72036 16.7046 9.72036 17.8718C9.72036 18.9778 8.87211 19.5938 7.92961 19.5938H6.71977V20.5178C6.71977 20.8258 6.51677 21 6.25577 21C6.01652 21 5.76367 20.8258 5.76367 20.5178V16.5786ZM6.71977 16.9767V18.7197H7.92961C8.41536 18.7197 8.79961 18.3058 8.79961 17.8718C8.79961 17.3827 8.41536 16.9767 7.92961 16.9767H6.71977Z"
      fill="white" />
    <path
      d="M11.1389 20.9999C10.8997 20.9999 10.6387 20.8739 10.6387 20.5668V16.5926C10.6387 16.3414 10.8997 16.1586 11.1389 16.1586H12.7983C16.1097 16.1586 16.0372 20.9999 12.8635 20.9999H11.1389ZM11.5957 17.0126V20.1468H12.7983C14.7549 20.1468 14.8419 17.0126 12.7983 17.0126H11.5957Z"
      fill="white" />
    <path
      d="M17.2116 17.0686V18.1807H19.0595C19.3205 18.1807 19.5815 18.4327 19.5815 18.6768C19.5815 18.9078 19.3205 19.0968 19.0595 19.0968H17.2116V20.566C17.2116 20.811 17.0313 20.9991 16.7775 20.9991C16.4585 20.9991 16.2637 20.811 16.2637 20.566V16.5917C16.2637 16.3406 16.4594 16.1577 16.7775 16.1577H19.3214C19.6404 16.1577 19.8289 16.3406 19.8289 16.5917C19.8289 16.8157 19.6404 17.0677 19.3214 17.0677H17.2116V17.0686Z"
      fill="white" />
    <path
      d="M22.6562 23.625H5.4375V24.5H22.6562C23.1547 24.5 23.5625 24.1063 23.5625 23.625V22.75C23.5625 23.2313 23.1547 23.625 22.6562 23.625Z"
      fill="#CAD1D8" />
  </svg>
</template>
